export const ID_CARD_ITEM = "tarjeta-beneficios-id";
export const NEWS = "Novedades";
